"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCALE_CATEGORY_KEY = 'base';
exports.SCALE_COMPONENT_KEY = 'scale';